const projects = {
  permissionSource: 'api::project.project',
  creationTitle: 'Create Project',
  creationEndPoint: '/projects',
  detailTitle: 'Project: :title',
  detailEndPoint:
    '/projects/:id?populate[0]=business_entity&populate[1]=client.whatsapp&populate[2]=equipments&populate[3]=gallery&populate[4]=inspectors&populate[5]=prepared_bys&populate[6]=project_types&populate[7]=staffs&populate[8]=project_detail.supporting_media&populate[9]=project_detail.doc_type&populate[10]=other_parties.client&populate[11]=other_parties.partner&populate[12]=other_parties.supplier&populate[13]=other_parties.supporting_media&populate[14]=other_parties.agent_fee_due_proof&populate[15]=contact_person',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Project Code',
          required: true,
        },
        {
          label: 'Business Entity',
          value: 'business_entity',
          tag: 'single-select',
          dataSourceUrl: '/business-entities',
          dataLabel: 'title',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Name',
          value: 'name',
          tag: 'input',
          type: 'text',
          placeholder: 'Project Name',
          required: true,
        },
        {
          label: 'Address',
          value: 'address',
          tag: 'richTextarea',
          placeholder: 'Project Address',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Client',
          value: 'client',
          tag: 'single-select',
          dataSourceUrl: '/clients',
          dataLabel: 'name',
          required: true,
        },
        {
          label: "Contact Person (Client's side)",
          value: 'contact_person',
          tag: 'single-select',
          dataSourceUrl: '/contact-people',
          dataLabel: 'name',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Project Start Date',
          value: 'project_datetime',
          tag: 'datetime-picker',
        },
        {
          label: 'Expected Project End Date',
          value: 'project_end_datetime',
          tag: 'datetime-picker',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Staffs',
          value: 'staffs',
          tag: 'multi-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
        },
        {
          label: 'Project Types',
          value: 'project_types',
          tag: 'multi-select',
          dataSourceUrl: '/project-types',
          dataLabel: 'title',
        },
      ],
    },
    {
      label: 'Objective',
      value: 'objective',
      tag: 'richTextarea',
    },
    {
      label: 'Remarks',
      value: 'remarks',
      tag: 'richTextarea',
    },
    {
      isLayout: true,
      layoutPattern: '1',
      children: [
        {
          label: 'Inspectors',
          value: 'inspectors',
          tag: 'multi-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
        },
        {
          label: 'Prepared By',
          value: 'prepared_bys',
          tag: 'multi-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
        },
        {
          label: 'Equipments',
          value: 'equipments',
          tag: 'multi-select',
          dataSourceUrl: '/equipments',
          dataLabel: 'title',
        },
        {
          label: 'Methods and Sampling Conditions',
          value: 'methods_and_sampling_conditions',
          tag: 'richTextarea',
        },
        {
          label: 'Conclusion',
          value: 'conclusion',
          tag: 'richTextarea',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default projects
